import { defineMessage } from 'services/localization';

export const messages = {
    description: defineMessage('please_note_that_the_ba__changed_in_approvalmax'),
    expectedBankAccount: defineMessage('contact_bank_account'),
    actualBankAccount: defineMessage('updated_bank_account'),
};
